import { useEffect, useState } from 'react'

import { useNavigate } from 'react-router-dom'

import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes.ts'

import { useTourLimits } from 'entities/tour/hooks/useTourLimits'
import { preparedDataForSpecialTour } from 'entities/tour/libs/preparedDataForSpecialTour.tsx'
import searchTour from 'entities/tour/models/search-tour/search-tour.ts'
import specialTourStore from 'entities/tour/models/special-tour/special-tour.ts'
import { SpecialToursUi } from 'entities/tour/ui'
import { SpecialToursCardSkeleton } from 'entities/tour/ui/special-tours/components/special-tours-card-skeleton'
import { useSpecialTours } from 'entities/tour/ui/special-tours/libs/useSpecialTours.ts'

import { SpecialTour } from 'shared/api/tours/search'

export const SpecialTours = observer(() => {
  const navigate = useNavigate()

  const [activeTag, setActiveTag] = useState<string | null>(null)

  const { checkHasLimitedTour } = useTourLimits()
  const specialToursData = specialTourStore.getSpecialTourList()
  const isLoading = specialTourStore.isLoading

  const { tours, categories } = useSpecialTours(
    activeTag ?? specialToursData?.[0]?.id,
    specialToursData,
  )

  const fetchSpecialTours = async () => {
    if (!specialToursData?.length)
      void specialTourStore.requestSpecialToursList()
  }

  const onClickTour = (tour: SpecialTour) => {
    const preparedData = preparedDataForSpecialTour(tour)

    searchTour.setDataForSearchTour(preparedData)

    navigate(RoutingPaths.tours.searchResults.path())
  }

  const onClickAll = () => {
    navigate(RoutingPaths.tours.specialTours.base())
  }

  const onTagClick = (id: string) => {
    setActiveTag(id)
  }

  useEffect(() => {
    void fetchSpecialTours()
  }, [])

  return isLoading ? (
    <SpecialToursCardSkeleton />
  ) : (
    <SpecialToursUi
      tours={tours}
      categories={categories}
      onClickTour={(tour) => checkHasLimitedTour(() => onClickTour(tour))}
      onClickAll={() => checkHasLimitedTour(onClickAll)}
      onTagClick={onTagClick}
    />
  )
})
